export type FlowType = 'self' | 'support' | 'others';

const allFlowType: FlowType[] = ['self', 'support', 'others'];

export const isFlowType = (v: string): v is FlowType => (allFlowType as string[]).includes(v);
